import React from 'react';

import config from 'config';

import PageRouter, { type PageRouterProps } from './PageRouter';
import Header from 'components/common/layouts/header/Header';

import { UserContext } from 'components/App';
import Maintenance from 'components/common/maintenance/Maintenance';

import { useUserInfoQuery, useUserNotices } from 'hooks/query/useUserInfo';
import type { ServiceId } from 'interface/service';

interface PageProps {
  userRoles?: string[];
  isUserRoleLoading?: boolean;
}

const Page: React.FC<PageProps> = ({ userRoles, isUserRoleLoading }) => {
  const notices = useUserNotices();
  const { isLoading: isNoticeCountLoading } = useUserInfoQuery();
  const noticeCount = notices?.length;

  return (
    <UserContext.Consumer>
      {(user) => {
        if (typeof user === 'string') {
          return null;
        }

        const pageRouterProps: PageRouterProps = {
          user,
          noticeCount,
          isNoticeCountLoading,
        };

        return (
          <>
            <Header
              user={user as { id: ServiceId; firstName: string; lastName: string; avatarUrl: string }}
              noticeCount={noticeCount}
              isNoticeCountLoading={isNoticeCountLoading}
              userRoles={userRoles}
              isUserRoleLoading={isUserRoleLoading}
            />
            {config.isMaintenanceMode ? <Maintenance /> : <PageRouter {...pageRouterProps} />}
          </>
        );
      }}
    </UserContext.Consumer>
  );
};

export default Page;
